"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateTimeField = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const googleProtobufConverters_1 = require("@mesh/common-js/dist/googleProtobufConverters");
const dayjs_1 = __importDefault(require("dayjs"));
const utc_1 = __importDefault(require("dayjs/plugin/utc"));
const timezone_1 = __importDefault(require("dayjs/plugin/timezone"));
const i8n_1 = require("@mesh/common-js/dist/i8n");
const x_date_pickers_1 = require("@mui/x-date-pickers");
require("@mui/x-date-pickers/AdapterDayjs");
dayjs_1.default.extend(utc_1.default);
dayjs_1.default.extend(timezone_1.default);
function DateTimeField(props) {
    return ((0, jsx_runtime_1.jsx)(x_date_pickers_1.DateTimePicker, Object.assign({}, props, { timezone: props.timezone ? (0, i8n_1.timezoneToString)(props.timezone) : "system", value: props.value ? (0, googleProtobufConverters_1.protobufTimestampToDayjs)(props.value) : null, onChange: (newValue) => {
            if (!props.onChange)
                return;
            props.onChange(newValue ? (0, googleProtobufConverters_1.dayjsToProtobufTimestamp)(newValue) : undefined);
        }, slotProps: {
            textField: {
                id: props.id,
                error: props.error,
                helperText: props.helperText,
                variant: props.readOnly ? "standard" : "outlined",
                InputProps: (() => {
                    const addProps = {
                        readOnly: props.readOnly,
                        disableUnderline: props.readOnly,
                    };
                    if (props.readOnly) {
                        addProps.endAdornment = undefined;
                    }
                    return addProps;
                })(),
            },
            actionBar: {
                actions: props.nullable
                    ? ["clear", "cancel", "accept"]
                    : ["cancel", "accept"],
            },
        } })));
}
exports.DateTimeField = DateTimeField;
